import * as React from 'react'

export function logRefTag(refTag: string) {
  fetch(`/gp/video/ajax/analytics.html/ref=${refTag}`, {
    method: 'POST'
  })
}

export interface IRecordRefTagProps {
  refTag?: string
  children?: JSX.Element
  className?: string
}

export const RecordRefTag = ({
  refTag,
  children,
  className = ''
}: IRecordRefTagProps) =>
  !refTag ? (
    <>children</>
  ) : (
    <span
      className={className}
      onClick={() => logRefTag(refTag)}>
      {children}
    </span>
  )
